/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 14.05.24
 *
 */
import BaseObject from "@shared/BaseObject.js";

export default class FormSettings extends BaseObject {

	showSingleQuestionPerPage: boolean = false;
	collectNameAndEmailAfterSubmit: boolean = false;
	redirectOnCompletion: boolean = false;
	redirectUrl: string = null;
	showResultAfterCompletion: boolean = true;

	collectName: boolean = true;
	collectEmail: boolean = true;
	collectPhone: boolean = false;
	collectAddress: boolean = false;
	collectDateOfBirth: boolean = false;
	collectEmergencyContacts: boolean = false;

	constructor() {
		super();
	}

	resetCollectInfoSettings(){
		this.collectName = false;
		this.collectEmail = false;
		this.collectPhone = false;
		this.collectAddress = false;
		this.collectDateOfBirth = false;
		this.collectEmergencyContacts = false;
	}

	canRedirect(){
		return this.redirectOnCompletion && this.redirectUrl;
	}


}
